// extracted by mini-css-extract-plugin
module.exports = {"container":"CountsCard_container__z018U","title":"CountsCard_title__lSjy4"};